// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3k9jx","col":"styles_col__2yPMo","actions":"styles_actions__e5Pj8","conflict":"styles_conflict__Qwvil"};